import { useState } from "react";
import DC2500E from "../../assets/images/Dualcab.jpg";
import ContactFormModal from "../header/HomeHeader/contact/ContactFormModal";

const AllModelsBennar = () => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="relative w-full overflow-hidden min-h-[420px] sm:min-h-[500px] md:min-h-[600px] lg:min-h-[650px]">
      <img
        src={DC2500E}
        alt="Tuatara UTVs Powered By Gas & Electric"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 flex items-center justify-center px-3 py-6 sm:px-6 sm:py-8 md:px-8 md:py-10">
        <div className="bg-[rgba(0,0,0,0.55)] px-4 py-5 sm:px-8 sm:py-8 md:px-10 md:py-10 w-full max-w-[1000px] text-center rounded-xl text-white">
          <h1 className="font-[Rockwell] text-white font-bold 2xl:text-[30px] xl:text-[30px] lg:text-[28px] md:text-[24px] sm:text-[20px] text-[15px] leading-tight text-center uppercase">
            Tuatara UTVs Powered By Gas &amp; Electric
          </h1>
          <div className="flex items-center justify-center mt-[5px] mb-3 sm:mb-[20px]">
            <div className="bg-[#fff] sm:h-[8px] h-[4px] sm:w-[350px] w-[120px]"></div>
          </div>
          <p className="font-[Roboto] text-white font-bold lg:text-[18px] md:text-[16px] sm:text-[14px] text-[12px] leading-relaxed text-center mb-3 sm:mb-4">
            Tuatara offers a versatile range of <strong>gas and electric UTVs</strong> built to handle real work across farms, job sites, and rugged terrain. Whether you need the power and range of a gas-powered model or the efficiency and low maintenance of an electric utility vehicle, there's a Tuatara UTV designed to match your workload.
          </p>
          <p className="font-[Roboto] text-white font-bold lg:text-[18px] md:text-[16px] sm:text-[14px] text-[12px] leading-relaxed text-center mb-5 sm:mb-6">
            Engineered for durability and performance, our <strong>utility vehicles</strong> combine heavy-duty construction, strong payload capacity, and all-terrain capability to keep you moving in demanding conditions. From daily operations to off-road tasks, Tuatara UTVs deliver reliable performance you can count on.
          </p>
          <button
            onClick={() => setContactOpen(true)}
            className="bg-[#6FBF4A] text-white px-5 py-2 sm:px-5 sm:py-3 text-[12px] sm:text-sm md:text-base font-semibold uppercase hover:opacity-90 transition"
          >
            Contact Us
          </button>
          <ContactFormModal
            open={contactOpen}
            handleClose={() => setContactOpen(false)}
          />
        </div>
      </div>
    </div>
  );
};
export default AllModelsBennar;
